export default __webpack_public_path__ + "static/media/flag-cbf.44deeed0.png";